// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "/* Variables */\n[data-v-499bdf6c]:export {\n  menuBg: #101820;\n  menuText: #8a97bb;\n  menuActiveText: #e48f93;\n  menuActiveBg: #934054;\n}\n\n/* Mixins */\n.el-tag[data-v-499bdf6c] {\n  margin-right: 4px;\n}\n.input-new-tag[data-v-499bdf6c] {\n  width: 100px;\n}", ""]);
// Exports
module.exports = exports;
